import { Typography, Link as MuiLink, Box, useTheme } from '@mui/material'
import { Link as RouterLink } from 'react-router'
import { ComponentProps } from 'react'

export interface LinkProps {
  children: string
  to: string
  sx?: React.CSSProperties
  onClick?: () => void
  isEmail?: boolean
  target?: string
  variant?: ComponentProps<typeof Typography>['variant']
}

export const Link = ({ children, to, sx, onClick, isEmail, target, variant = 'body2' }: LinkProps) => {
  const theme = useTheme()
  const defaultStyle = {
    color: theme.palette.text.secondary,
    textDecorationColor: theme.palette.text.secondary,
    marginTop: '0.5rem',
    lineHeight: '20px',
  }

  return isEmail || target ? (
    <Box sx={{ display: 'flex' }}>
      <MuiLink href={to} style={{ ...defaultStyle, ...sx }} target={target}>
        <Typography variant={variant}>{children}</Typography>
      </MuiLink>
    </Box>
  ) : (
    <Box sx={{ display: 'flex' }}>
      <RouterLink
        to={to}
        onClick={onClick}
        style={{
          ...defaultStyle,
          ...sx,
        }}
      >
        <Typography variant={variant}>{children}</Typography>
      </RouterLink>
    </Box>
  )
}

export default Link
